import React from 'react';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { useStepperWrapperLogic } from './StepperWrapper.hook';
import { LivenStepper } from './components/livenstepper/Stepper';
import LoonaLogo from 'assets/livenicons/loona_logo.svg';
import Navigation from 'assets/livenicons/ic_navigation.svg';
import { push } from 'connected-react-router';
import { useAppDispatch } from 'bootstrap/hooks';
import styles from './stylesLiven.module.scss';

type Props = {
  questionId: QuestionIds;
  className: string;
  withStepper?: boolean;
};

export const LivenHeaderWrapper = ({
  questionId,
  className,
  withStepper,
}: Props) => {
  const { stepName, currentStep, stepsTotal, currentSubstep, substepsTotal } =
    useStepperWrapperLogic({ questionId });

  const dispatch = useAppDispatch();

  return (
    <div
      className={`${styles.wrapper} ${
        withStepper ? styles.withWrapper : styles.marginBottom
      }`}
    >
      <div className={styles.contentWrapper}>
        <img
          src={Navigation}
          className={styles.navigation}
          alt="navigation"
          onClick={() => window.history.back()}
        />
        <img
          src={LoonaLogo}
          className={styles.logo}
          alt="logo"
          onClick={() => dispatch(push('/'))}
        />
        <p>{withStepper ? `${currentSubstep} / ${substepsTotal}` : ''}</p>
      </div>
      {withStepper && (
        <LivenStepper
          stepName={stepName}
          currentStep={currentStep}
          stepsTotal={stepsTotal}
          currentSubstep={currentSubstep}
          substepsTotal={substepsTotal}
          className={className}
        />
      )}
    </div>
  );
};
